import { thunk } from 'redux-thunk';
import * as Common from "./common";
import * as Views from "./payment";
import Mixpanel from "../init/mixpanel";
import getDeviceFingerprint from "../init/fingerprint";
import ErrorState from "./common/error";
import NoopView from "./payment/common/noop";
import initializeForter from "../init/forter";
import getChargeData from "../init/chargedata";
import SearchParams from "../init/searchparams";
import getTimeout from "../init/sessiontimeout";
import setupChargeFunctions from "./payment/helpers/charge";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { isPlainObject, objectWithAccessors, withProperties } from "../utils";

let $ready, $dispatched = false;

const STORE = createStore(
  __getStoreReducer__(),
  applyMiddleware(thunk)
);

function __getStoreReducer__() {
  return combineReducers({
    // amount: { current: null, fee: null, discount: null },
    ...Common.reducers,
    ...Views.reducers
  });
}

function __getExportedContext__() {
  const { dispatch, getState, subscribe } = STORE;

  const $context = objectWithAccessors({
    dispatch: () => dispatch,
    getState: () => getState,
    subscribe: () => subscribe
  }, false);

  return Object.freeze(withProperties($context, {
    ...Common.actions
  }));
}

function __dispatch__($ready) {
  if ($dispatched !== true) {
    $dispatched = true;
    dispatchEvent($ready);
  }
}

function __initialize__() {
  if (!$ready) {
    $ready = getChargeData()
      .then(data => {
        const $data = { ...(isPlainObject(data) ? data : {}) };

        initializeForter();
        Mixpanel.init();

        getDeviceFingerprint();

        Object.defineProperty(STORE, "refresh", {
          value() { return STORE.replaceReducer(__getStoreReducer__()) }
        });

        setupChargeFunctions($data, STORE);
        getTimeout($data, STORE);

        Views.initialize($data, STORE);
        Common.initialize($data, STORE);

        STORE.refresh();

        if (SearchParams.hasErrors()) {
          NoopView && NoopView.activate(() => {
            STORE.dispatch(ErrorState.actions.updateErrorMessage(
              SearchParams.getError()
            ));
          });
        }

        return new CustomEvent("checkout:ready", {
          bubbles: false,
          cancelable: false,
          detail: objectWithAccessors({
            store: __getExportedContext__
          })
        });
      });
  }
  
  return $ready;
}

addEventListener("checkout:app", function _ready() {
  removeEventListener("checkout:app", _ready, false);
  __initialize__().then(__dispatch__);
}, false);

__initialize__().then(__dispatch__);

export default STORE;
